var gql = require("@apollo/client").gql;

const MUTATE_WEB_VITALS = gql`
	mutation (
		$metric_inp_value: Int
		$metric_id: String
		$metric_inp_event_target: String
		$metric_inp_event_type: String
		$metric_inp_load_state: String
		$metric_inp_start_time: Float
		$metric_inp_processing_start: Float
		$metric_inp_processing_end: Float
		$metric_inp_duration: Int
		$metric_inp_interaction_id: Int
		$url: String
		$release: String
	) {
		webVitals(
			metric_inp_value: $metric_inp_value
			metric_id: $metric_id
			metric_inp_event_target: $metric_inp_event_target
			metric_inp_event_type: $metric_inp_event_type
			metric_inp_load_state: $metric_inp_load_state
			metric_inp_start_time: $metric_inp_start_time
			metric_inp_processing_start: $metric_inp_processing_start
			metric_inp_processing_end: $metric_inp_processing_end
			metric_inp_duration: $metric_inp_duration
			metric_inp_interaction_id: $metric_inp_interaction_id
			url: $url
			release: $release
		)
	}
`;

export default MUTATE_WEB_VITALS;
